import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { invitationConfirm } from '../../../Login/AuthService';
import { useNavigate, useParams } from 'react-router-dom';

const Form = (): JSX.Element => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');

  const onSubmit = async () => {
    try {
      const response = await invitationConfirm(token);
      if (response.status === 200) {
        navigate('/login');
        window.location.reload();
        console.log('Account successfully verified.');
      } else {
        console.log('Registration did not work.');
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('Link did not work. Please try again later.');
    }
  };

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 'medium',
          }}
          gutterBottom
          color={'text.secondary'}
        >
          Verify your account
        </Typography>
      </Box>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button color="primary" variant="contained" fullWidth type="submit">
              Confirm invitation
            </Button>
          </Grid>
        </Grid>
        {errorMessage && (
          <Typography color="error" variant="body2" gutterBottom>
            {errorMessage}
          </Typography>
        )}
      </form>
    </Box>
  );
};

export default Form;
